export default "__VITE_ASSET__DFbEuftb__"